module.exports = __webpack_public_path__ + "media/images/emblems/Etoy-coat_of_arms-bf95a2addcd15264cbede780adf64896.svg";